<ion-content class="cost-center-employee">
  <ng-container>
    <app-header [title]="'Cost Center Employee View'"></app-header>
     <div class="loading-container" style="padding-top:15%;" *ngIf="!loaded">
        <ion-spinner></ion-spinner>
    </div>
    <ion-grid>
      <ion-row class="table-row">
        <div class="ion-padding table-container" *ngIf="!submitting">
          <app-cost-center-report-table  [mode]="'gl'" (paging)="setPage($event)" [pageType]="authService.user?.isCostCenterUser ? 'costCenter' : 'costCenter'"  [pageSize]="pageSize" [pageNumber]="currPage" [rows]="rows" [currentRoute]="currentRoute" [totalElements]="totalElements"></app-cost-center-report-table>
        </div>
      </ion-row>
    </ion-grid>
  </ng-container>
</ion-content>
